import { useState } from "react";

type Errors = string[];
type SetErrorFn = (err: Record<string, string[]>) => void;
type ClearErrorFn = () => void;
type GetFirstErrorFn = () => string | false;

export function useValidationError(): [
	Errors,
	SetErrorFn,
	ClearErrorFn,
	GetFirstErrorFn,
] {
	const [errors, setErrors] = useState<Errors>([]);

	const setErrorFn: SetErrorFn = (err) => {
		const newErrors = [];

		for (const key in err) {
			if (err.hasOwnProperty(key)) {
				newErrors.push(err[key][0]);
			}
		}

		setErrors(newErrors);
	};

	const clearErrorFn: ClearErrorFn = () => {
		setErrors([]);
	};

	//returns first error
	const getFirstError: GetFirstErrorFn = () => {
		if (errors.length) {
			return errors[0];
		}

		return false;
	};

	return [errors, setErrorFn, clearErrorFn, getFirstError];
}
